export interface SparklineProps {
  values: number[]
  width?: number
  height?: number
  /** Accessible description of the trend. */
  label?: string
}

// Sparkline is a tokenized SVG trend line + soft area fill for dashboard cards
// (KAT-297 charts). It scales to its data and degrades to a flat baseline when
// every value is equal or the series is empty.
export function Sparkline({ values, width = 160, height = 44, label }: SparklineProps) {
  const role = label ? 'img' : 'presentation'
  if (values.length === 0) {
    return <svg width={width} height={height} role={role} aria-label={label} />
  }
  const max = Math.max(...values)
  const min = Math.min(...values)
  const span = max - min || 1
  const stepX = values.length > 1 ? width / (values.length - 1) : 0
  const points = values.map((v, i) => {
    const x = i * stepX
    const y = height - ((v - min) / span) * (height - 4) - 2
    return [x, y] as const
  })
  const line = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ')
  const area = `${line} L${width},${height} L0,${height} Z`

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role={role} aria-label={label}>
      <path d={area} fill="var(--c-accent-soft)" stroke="none" />
      <path d={line} fill="none" stroke="var(--c-accent)" strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  )
}
